export default "__VITE_ASSET__1af5e7c7__"